import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  selectFacilityList: {
    width: "100%",
    padding: 20,
    display: "flex",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      flexDirection: "column",
      padding: 0
    }
  },
  selectFacilityListLeft: {
    flexBasis: "50%",
    paddingRight: 10,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      padding: 0
    }
  },
  selectFacilityListRight: {
    flexBasis: "50%",
    paddingLeft: 10,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      padding: 0
    }
  },
  facilityItem: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #000000",
    borderRadius: 3,
    marginBottom: 10,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      margin: 0,
      borderRadius: 0,
      border: "none",
      borderBottom: "1px solid #e2e2e2"
    },
    "&:hover": {
      cursor: "pointer"
    }
  },
  facilityContentContainer: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 20px",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      padding: "0 14px"
    }
  },
  facilityName: {
    color: "#2d2d2d",
    fontWeight: 600
  },
  openAppIcon: {
    color: theme.palette.text.secondary,
    fontSize: 20
  },
  capitalize: {
    textTransform: "capitalize"
  }
}));
